import React from "react";
import styles from "./PopularProducts.module.css";

//components
import { CardItemSmallList } from "../../Card";
import Title from "../../../components/Title";
import Grid from "@material-ui/core/Grid";

const PopularProducts = ({ itemOnRow, size }) => {
  return (
    <div className={styles.container}>
      <Title name={"SẢN PHẨM MỚI"} />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CardItemSmallList itemOnRow={itemOnRow} size={size} />
        </Grid>
      </Grid>
    </div>
  );
};

export default PopularProducts;
